<div class="container">
    <div class="row mt-4">
        <div class="col-12">
            <h4>Área Administrativa</h4>
        </div>
        <div class="col-12">
            <hr>
        </div>
    </div>
    <div class="row">
        <div class="col-3">
            <mat-card class="dashboardCardColor cursor-pointer" (click)="form()">
                <mat-card-header matTooltip="Formulários do Sistema">
                    <div mat-card-avatar [style.background-image]="'url(../../../assets/cliente.png)'"
                        class="imageCard mt-2"></div>
                    <mat-card-subtitle class="dashboardCardTexto mt-3">Formulários do Sistema</mat-card-subtitle>
                </mat-card-header>
            </mat-card>
        </div>
        <div class="col-3">
            <mat-card class="dashboardCardColor cursor-pointer" (click)="listUser()" *ngIf="adm">
                <mat-card-header matTooltip="Usuários gestores">
                    <div mat-card-avatar [style.background-image]="'url(../../../assets/cliente.png)'"
                        class="imageCard mt-2"></div>
                    <mat-card-subtitle class="dashboardCardTexto mt-3">Usuários gestores</mat-card-subtitle>
                </mat-card-header>
            </mat-card>
        </div>
        <div class="col-3">
            <mat-card class="dashboardCardColor cursor-pointer" (click)="pc003()" *ngIf="adm">
                <mat-card-header matTooltip="PC-003">
                    <div mat-card-avatar [style.background-image]="'url(../../../assets/cliente.png)'"
                        class="imageCard mt-2"></div>
                    <mat-card-subtitle class="dashboardCardTexto mt-3">PC-003</mat-card-subtitle>
                </mat-card-header>
            </mat-card>
        </div>

        <div class="col-3">

            <mat-card class="dashboardCardColor cursor-pointer" (click)="humity()" *ngIf="adm">
                <mat-card-header matTooltip="Umidade">
                    <div mat-card-avatar [style.background-image]="'url(../../../assets/cliente.png)'"
                        class="imageCard mt-2"></div>
                    <mat-card-subtitle class="dashboardCardTexto mt-3">Umidade</mat-card-subtitle>
                </mat-card-header>
            </mat-card>
        </div>

        <div class="col-3">
            <mat-card class="dashboardCardColor cursor-pointer" (click)="listPc003Estrategia()">
                <mat-card-header matTooltip="Orientações Estratégia Torre">
                    <div mat-card-avatar [style.background-image]="'url(../../../assets/cliente.png)'"
                        class="imageCard mt-2"></div>
                    <mat-card-subtitle class="dashboardCardTexto mt-3">Orientações Estratégia Torre</mat-card-subtitle>
                </mat-card-header>
            </mat-card>
        </div>
    </div>
</div>